import {
  ACR_REPORT_STATE_TRANSITION_ACTION,
  CHANGE_DATE_PICKER_ACTION,
  CHANGE_DATE_PICKER_KEY,
  CLEAN_REPORT_DATA_ACTION,
  POST_ACR_REPORTS_STATE_TRANSITION_KEY,
} from 'src/redux/constants';
import type { ViewAction, ViewActionPayload } from 'src/redux/viewState/types';

export const postAcrReportStateTransition = (
  params: ViewActionPayload,
): ViewAction => {
  return {
    type: ACR_REPORT_STATE_TRANSITION_ACTION,
    dataKey: POST_ACR_REPORTS_STATE_TRANSITION_KEY,
    value: params,
  };
};

export const changeDatePicker = (
  dateValue: ViewActionPayload,
  state: ViewActionPayload,
  reportPk: ViewActionPayload,
  period: ViewActionPayload,
): ViewAction => {
  return {
    type: CHANGE_DATE_PICKER_ACTION,
    dataKey: CHANGE_DATE_PICKER_KEY,
    value: { dateValue, state, reportPk, period },
  };
};

export const cleanReportDataDetail = (): ViewAction => {
  return {
    type: CLEAN_REPORT_DATA_ACTION,
  };
};
